module.exports = __webpack_public_path__ + "img/hr-tree-03-f-trunk.2d9619cf.png";